<template>
    <div class="social-media-block">
        <div class="social-media-block__inner">
            <h1 class="social-media-block__inner__heading">{{ data.primary.social_media_heading[0].text }}</h1>
            <!-- arrows -->
            <div class="social-media-block__inner__icons">
                <icon icon="4-arrow-up" class="social-media-block__inner__icons__arrow" />
            </div>
            <div class="social-media-block__inner__socials">
                <btn
                    v-for="(social, index) in socials"
                    :key="index"
                    tag="a"
                    :href="social.url"
                    :label="social.title"
                    color="lighter"
                    :iconAfter="social.name"
                    target="_blank"
                    rel="noopener"
                    :isFullWidth="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "objects/Icon";
import Btn from "components/Btn";

export default {
    name: "SocialMediasBlock",
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    components: {
        Icon,
        Btn
    },
    data() {
        return {
            socials: [
                {
                    name: "instagram",
                    title: "Instagram",
                    url: "https://www.instagram.com/mois_economiesociale/"
                },
                {
                    name: "facebook",
                    title: "Facebook",
                    url: "https://www.facebook.com/economiesocialeQc/"
                }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.social-media-block {
    @include sectionColouredPadding;
    @include sharedParentBody;

    &__inner {
        max-width: 900px;
        /* background-color: blue; */
        /* height: 100%; */
        display: flex;
        flex-direction: column;
        text-align: center;
        &__icons {
            display: flex;
            justify-content: center;
            &::v-deep svg {
                max-width: 40vw;
                max-height: 40vw;
                width: 100%;
                stroke: $color-dark;
                stroke-width: 12px;
                @media #{$breakpoint-horizontal} {
                    max-width: 250px;
                }
            }
            &__arrow {
                transform: rotate(180deg);
                padding: var(--grid-gutter) 0;
            }
        }
        h1 {
            @include t1-heavy;
            color: $color-bright;
            padding-top: var(--grid-gutter);
            @media #{$breakpoint-horizontal} {
                padding-top: var(--grid-gutter-double);
            }
        }

        &__socials {
            display: flex;
            justify-content: center;
            flex-direction: row;
            flex-wrap: wrap;
            gap: var(--grid-gutter-half);
            margin: var(--grid-gutter);
        }
    }
}
</style>
